










// Vue
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Mixins } from 'vue-mixin-decorator';
import { mapGetters, mapActions } from 'vuex';

// Third party
import dayjs, { UnitType } from 'dayjs';
import 'dayjs/locale/es';

// Constants
import Assets from '@/constants/assets.ts';
import UtilsService from '@/core/services/utils.service';

// Components
import Btn, { BtnColor, BtnWidth } from '@/shared/components/btn.component.vue';
import DropUp, {
  DropUpColorHover,
} from '@/shared/components/DropUp.component.vue';
import Icon, { IconEnum } from '@/shared/components/icon.component.vue';
import Pagination from '@/shared/components/Pagination/Pagination.component.vue';
import ItemThumb from '@/shared/components/item-thumb.component.vue';
import Spinner from '@/shared/components/Spinner.component.vue';
import TableColumnOrder from '@/shared/components/TableColumnOrder.component.vue';
import ButtonSwitch, {
  SwitchActiveColor,
} from '@/shared/components/button-switch.component.vue';
import Datepicker, { DatepickerBorder } from '@/shared/components/datepicker/index.vue';

// Components - Views
import BudgetRow from '@/manager/budget/views/budget-row/index.vue';
import EditBudgetModal from '@/manager/budget/views/edit-budget-modal/index.vue';
import TopBar from '@/shared/components/TopBar.component.vue';
import Search, {
  SearchPredefinedStyle,
} from '@/shared/components/search.component.vue';
import EmptyState from '@/shared/components/empty-state.component.vue';
import SpotlightText from '@/shared/components/SpotlightText.component.vue';
import GenerateRemittanceModal from '@/manager/budget/views/generate-remittance-modal/index.vue';
import FlatSelectorText, {
  FlatSelectorTextPredefinedStyle,
  FlatSelectorTextBorderBottom,
  FlatSelectorTextWeight,
} from '@/shared/components/FlatSelectorText.component.vue';

// Models - Interfaces
import { Convocation } from '@/manager/convocation/convocation.model';
import { SecondLevelOptionModel } from '@/shared/models/secondLevelOption.model';
import { TimetablesInterface } from '@/shared/interfaces/timetables.interface';
import { Purchase } from '@/clickbuy/purchase/models/purchase.model';
import {
  Budget,
  BudgetStatus,
  BudgetPaymentStatus,
  BudgetPaymentStatusLiteral,
} from '@/manager/budget/models/budget.model';

// Services
import BudgetService from '@/manager/budget/budget.service';

// Mixins
import WithSpinner from '@/shared/mixins/withSpinner.mixin.ts';
import WithPagination from '@/shared/mixins/withPagination.mixin.ts';
import ColumnOrderMixin from '@/shared/mixins/columnOrder.mixin.ts';
import NotificationMessage from '@/shared/mixins/notificationMessage.mixin.ts';
import SearchMixin from '@/shared/mixins/search.mixin.ts';

export enum ListActions {
  DownloadCsv = 'download-csv',
  GenerateConsignment = 'generate-consignment',
}

interface MixinInterface
  extends WithPagination,
  SearchMixin,
  NotificationMessage,
  ColumnOrderMixin { }

@Component({
  components: {
    EditBudgetModal,
    Btn,
    BudgetRow,
    ButtonSwitch,
    DropUp,
    Datepicker,
    FlatSelectorText,
    EmptyState,
    Icon,
    ItemThumb,
    Pagination,
    Spinner,
    TableColumnOrder,
    TopBar,
    Search,
    SpotlightText,
    GenerateRemittanceModal,
  },
  methods: {
    ...mapActions({
      setCurrentBudget: 'setCurrentBudget',
    }),
  },
  computed: {
    ...mapGetters({
      getBudgetList: 'getBudgetList',
      allowEditBudget: 'getAllowEditBudget',
      internalBusinessList: 'getInternalBusinessList',
    }),
  },
})
export default class BudgetList extends Mixins<MixinInterface>(
  WithPagination,
  SearchMixin,
  NotificationMessage,
  ColumnOrderMixin,
) {
  private assets = Assets;
  private dropUpColorHover = DropUpColorHover;
  private iconEnum = IconEnum;
  private btnColor = BtnColor;
  private btnWidth = BtnWidth;
  private searchPredefinedStyle = SearchPredefinedStyle;
  private datepickerBorder = DatepickerBorder;
  private flatSelectorTextPredefinedStyle = FlatSelectorTextPredefinedStyle;
  private flatSelectorTextBorderBottom = FlatSelectorTextBorderBottom;
  private flatSelectorTextWeight = FlatSelectorTextWeight;
  private getBudgetList!: any;
  private participantMassiveEmailList!: any;
  private loadingGroupFilters = true;
  private addBudgetModalOpened = false;
  private lastNoteTyped: string = '';
  private interval!: any;
  private allowEditBudget!: any;
  private cleanSearch = false;
  private budgetListLoaded = false;
  private alertDisplace = false;
  private listSwitchOptionSelected = this.listSwitchOptions[1];
  private budgetStatus = BudgetStatus.InProgress;
  private editBudgetModalOpened = false;
  private setCurrentBudget!: any;
  private remittanceModalOpened = false;
  // private searchString = new URLSearchParams(window.location.href.split('?')[1]) && new URLSearchParams(window.location.href.split('?')[1]).get('search-string') ? new URLSearchParams(window.location.href.split('?')[1]).get('search-string') : '';
  private modifyDataPrivateModal = false;
  private dateFrom = null;
  private dateTo = null;
  public internalBusinessList !: any;
  private searchFiscalData = "";
  protected searchNifString = '';
  private searchPublicIdString = '';
  public seriesList = [
    { 'name': 'VO/', 'id': 'VO/' },
    { 'name': 'R.VO/', 'id': 'R.VO/' },
    { 'name': 'ASECOURSE/', 'id': 'ASECOURSE/' },
    { 'name': 'R.ASECOURSE/', 'id': 'R.ASECOURSE/' },
    // { 'name': 'ASECONF/', 'id': 'ASECONF/' },
    // { 'name': 'R.ASECONF/', 'id': 'R.ASECONF/' },
    // {'name': 'ASEE/', 'id': 'ASEE/'}, 
    { 'name': 'CONF/', 'id': 'CONF/' },
    { 'name': 'R.CONF/', 'id': 'R.CONF/' },
    { 'name': 'COURSE/', 'id': 'COURSE/' },
    { 'name': 'R.COURSE/', 'id': 'R.COURSE/' },
    // {'name': 'E/', 'id': 'E/'}, 
    // {'name': 'D/', 'id': 'D/'},
    // {'name': 'R.ASEE/', 'id': 'R.ASEE/'}, 
    // {'name': 'R.E/', 'id': 'R.E/'}, 
    // {'name': 'R.D/', 'id': 'R.D/'}
    { 'name': 'GRUP/', 'id': 'GRUP/' },
    { 'name': 'R.GRUP/', 'id': 'R.GRUP/' },
    { 'name': 'IVGRUP/', 'id': 'IVGRUP/' },
    { 'name': 'R.IVGRUP/', 'id': 'R.IVGRUP/' },
    { 'name': 'CUBX/', 'id': 'CUBX/' },
    { 'name': 'R.CUBX/', 'id': 'R.CUBX/' },
    { 'name': 'IVCUBX/', 'id': 'IVCUBX/' },
    { 'name': 'R.IVCUBX/', 'id': 'R.IVCUBX/' },
    { 'name': 'M/', 'id': 'M/' },
    { 'name': 'R.M/', 'id': 'R.M/' },
    { 'name': 'REF/', 'id': 'REF/' },
    { 'name': 'R.REF/', 'id': 'R.REF/' },
    { 'name': 'FUND/', 'id': 'FUND/' },
    { 'name': 'R.FUND/', 'id': 'R.FUND/' },
  ]

  @Watch('dateTo')
  private watchDateTo(newVal: string, oldVal: string) {
    if (newVal !== oldVal && oldVal !== '') {
      this.fetchFirstPageList();
    }
  }

  @Watch('dateFrom')
  private watchDateFrom(newVal: string, oldVal: string) {
    if (newVal !== oldVal && oldVal !== '') {
      this.fetchFirstPageList();
    }
  }

  @Watch('searchFiscalData')
  private watchFiscalData(newVal: string, oldVal: string) {
    if (newVal !== oldVal) {
      this.fetchFirstPageList();
    }
  }

  @Watch('searchNifString')
  private watchSearchNifStringBudgetList(newVal: string, oldVal: string) {
    if (newVal !== oldVal) {
      this.fetchFirstPageList();
    }
  }

  @Watch('searchPublicIdString')
  private watchSearchPublicIdString(newVal: string, oldVal: string) {
    if (newVal !== oldVal) {
      this.fetchFirstPageList();
    }
  }

  get defaultDate() {
    const today = dayjs().toISOString();
    const from = dayjs().set('date', 1).set('month', 0).toISOString();
    return {
      from,
      to: today,
    };
  }

  private cleanFilters() {
    // this.searchString = "";
    // this.searchFiscalData = "";
    // // this.dateFrom = "";
    // // this.dateTo = "";
    // this.dateFrom = null;
    // this.dateTo = null;
    // this.defaultDate.from = "";
    // this.defaultDate.to = "";
    // this.searchInternalBusiness = "";
    // this.searchSerie = "";
    // this.defaultDate
    // this.dateRangeSelected(null, null)
    location.reload()
  }

  private dateRangeSelected(from: any, to: any) {
    if (from && to) {
      const dateFrom = UtilsService.setTimeToCero(dayjs(from)).toISOString();
      const dateTo = UtilsService.setTimeToLast(dayjs(to)).toISOString();

      this.dateFrom = dateFrom;
      this.dateTo = dateTo;
    } else {
      this.dateFrom = null;
      this.dateTo = null;
    }

  }

  private created() {
    this.changeSpinnerVisibility(true);
    this.fetchFirstPageList();
  }

  private setModifyDataPrivate(value: boolean) {
    this.modifyDataPrivateModal = value;
  }

  get openModal() {
    return this.editBudgetModalOpened;
  }

  get listSwitchOptions(): any[] {
    return [
      { id: BudgetStatus.Managed, text: 'Gestionadas' },
      {
        id: BudgetStatus.InProgress,
        text: 'En curso',
        activeColor: SwitchActiveColor.Primary,
      },
    ];
  }

  get showPagination() {
    return this.budgetListLoaded && !this.spinner.show;
  }

  get showTable() {
    return this.budgetListLoaded && !this.spinner.show;
  }

  get dropUpOption() {
    return [
      { value: ListActions.DownloadCsv, name: 'Exportar CSV' },
      { value: ListActions.GenerateConsignment, name: 'Generar remesa' },
    ];
  }

  get showEmptyState() {
    return (
      this.budgetListLoaded &&
      !this.spinner.show &&
      this.getBudgetList.length === 0
    );
  }

  public fetchList() {
    this.requestShowSpinner();
    this.changeSpinnerVisibility(true);
    this.fetchBudgetList((res: any) => {
      this.onFetchSuccess(res);
      this.budgetListLoaded = true;
      this.changeSpinnerVisibility(false);
    });
  }

  public searchCallback() {
    this.fetchFirstPageList();
  }

  private refetchList() {
    this.fetchFirstPageList();
  }

  public columnOrderFetchList() {
    this.requestShowSpinner();
    this.fetchBudgetList((res: any) => {
      this.columnOrderOnFetchSuccess();
      this.changeSpinnerVisibility(false);
    });
  }

  private handleComeBack() {
    this.cleanSearch = !this.cleanSearch;
    if (this.searchString === '') {
      this.fetchFirstPageList();
    } else {
      this.searchString = '';
    }
  }

  private fetchBudgetList(
    callback: any = () => {
      const doNothing = 1;
    },
  ) {

    const id = this.$route.params.id;

    if (id) {
      this.searchString = id;
    }

    this.$store
      .dispatch('fetchBudgetList', {
        offset: this.offset,
        limit: this.limit,
        search: this.searchString,
        status: this.budgetStatus,
        nif: this.searchNifString,
        public_id: this.searchPublicIdString,
        fiscalData: this.searchFiscalData,
        dateFrom: this.dateFrom,
        dateTo: this.dateTo,
      })
      .then(
        (res: any) => {
          this.changeSpinnerVisibility(false);
          callback(res);
        },
        (err: any) => {
          this.changeSpinnerVisibility(false);
        },
      );
  }

  private listSwitchOptionChange(option: any) {
    this.listSwitchOptionSelected = option;
    this.budgetStatus = option.id;
    this.fetchFirstPageList();
  }

  private closeRemittanceModal() {
    this.remittanceModalOpened = false;
  }

  private dropUpOptionSelected(option: any) {
    switch (option.value) {
      case ListActions.DownloadCsv:
        BudgetService.downloadCsv({
          search: this.searchString,
          nif: this.searchNifString,
          public_id: this.searchPublicIdString,
          fiscalData: this.searchFiscalData,
          dateFrom: this.dateFrom,
          dateTo: this.dateTo,
        });
        break;
      case ListActions.GenerateConsignment:
        this.remittanceModalOpened = true;
        break;
    }
  }

  private setEditBudgetModalOpened(value: boolean) {
    this.editBudgetModalOpened = value;
  }

  private closingModal() {
    this.modifyDataPrivateModal = false
    this.setEditBudgetModalOpened(false);
    this.setCurrentBudget(new Budget());
  }

  private newBudgetMessage(payload: any) {
    let message = 'Alta añadida con éxito';
    if (payload.edit) {
      message = 'Alta editada con éxito';
    }
    this.showMessage(message);
    this.fetchFirstPageList();
  }

  private showMessage(message: any) {
    let color = this.ownSpotlightTextColor.Primary;
    let text = message;
    if (message.error) {
      color = this.ownSpotlightTextColor.Error;
    }
    if (message.message) {
      text = message.message;
    }
    this.showNotification(text, color);
  }

  private topBarScrolled(scrolled: boolean) {
    this.alertDisplace = scrolled;
  }
}
